<template>
	<div style="height: 100%;">
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<div class="demo-split">
			<Split v-model="split1">
				<div slot="left" class="demo-split-pane">
					<Form ref="formInlineP" :model="formInlineP" inline style="text-align: left;margin-top: 1%;">
						<FormItem v-if='ifAddPrice' prop="trackName" label="查询模板名称:" :label-width="100">
							<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInlineP.Name">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<FormItem v-if='!ifAddPrice' prop="trackName" label="新增模板名称:" :label-width="100">
							<Input type="text" v-model="formInlineP.Name" placeholder="设备编号" />
						</FormItem>
						<FormItem v-if='!ifAddPrice'>
							<Button type="primary" @click="handleSubmitP('formInlineP')">新增模式</Button>
						</FormItem>
						<FormItem v-if='!ifAddPrice' style='float: right;'>
							<Button type="primary" @click="handleSubmitP('formInlineP')">保存</Button>
						</FormItem>
						<FormItem v-if='ifAddPrice'>
							<Button type="primary" @click="handleSubmitP('formInlineP')">查询模式</Button>
						</FormItem>
					</Form>
					<div style="border: 1px solid #d4cfc7;padding: 2px;">
						<el-form ref="formInlineP" :model="formInlineP" :label-position="labelPosition" inline
							style="text-align: left;margin-top: 1%;" size="mini">
							<el-row style="margin-top: 10px;">
								<el-col :span="4">
									<Button type="primary" icon="ios-search">时段1：</Button>
								</el-col>
								<el-col :span="5">
									<el-form-item prop="Period1BeginTime" label="开始时间:" :label-width="65">
										<el-time-select v-model="formInlineP.Period1BeginTime" :picker-options="{
									     start: '00:00',
									     step: '00:30',
									     end: '24:00'
									   }" placeholder="选择时间">
										</el-time-select>
									</el-form-item>
								</el-col>
								<el-col :span="5">
									<el-form-item prop="Period1EndTime" label="结束时间:" :label-width="65">
										<el-time-select v-model="formInlineP.Period1EndTime" :picker-options="{
									    start: '00:00',
									    step: '00:30',
									    end: '24:00'
									  }" placeholder="选择时间">
										</el-time-select>
									</el-form-item>
								</el-col>
								<el-col :span="5">
									<el-form-item prop="Period1Price" label="电费单价:" :label-width="65">
										<el-input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1Price"
											placeholder="电费单价" />
									</el-form-item>
								</el-col>
								<el-col :span="5">
									<el-form-item prop="Period1ServicePrice" label="服务费:" :label-width="65">
										<el-input :disabled="ifAddPrice" type="text"
											v-model="formInlineP.Period1ServicePrice" placeholder="服务费" />
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div>
				</div>
				<div slot="right" class="demo-split-pane">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
						<FormItem prop="trackName" label="充电站:" :label-width="100">
							<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="handleSubmit('formInline')">查询</Button>
						</FormItem>
					</Form>
					<Table :columns="columns1" :data="data1" :height="tableHeight" size="small"></Table>
					<MyPage ref="sonPage" :param="pageParam" :url="getStationInfoUrl" @listData='getDeviceData'>
					</MyPage>
				</div>
			</Split>
		</div>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	//import expandRow from './StationManagementExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				getStationInfoUrl: webapi.base_api_url + '/Archives/GetStationInfo',
				value: '',
				labelPosition: "left",
				split1: 0.5,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: "场站添加",
					type: "addStation"
				},
				modalView: false,
				ifAddPrice: false,
				formInlineP: {
					Name: '好的加个模板',
					Period1BeginTime: "",
					Period1EndTime: "",
					Period1Price: "",
					Period1ServicePrice: "",

					Period2BeginTime: "",
					Period2EndTime: "",
					Period2Price: "",
					Period2ServicePrice: "",

					Period3BeginTime: "",
					Period3EndTime: "",
					Period3Price: "",
					Period3ServicePrice: "",

					Period4BeginTime: "",
					Period4EndTime: "",
					Period4Price: "",
					Period4ServicePrice: "",

					Period5BeginTime: "",
					Period5EndTime: "",
					Period5Price: "",
					Period5ServicePrice: "",

					Period6BeginTime: "",
					Period6EndTime: "",
					Period6Price: "",
					Period6ServicePrice: "",

					Period7BeginTime: "",
					Period7EndTime: "",
					Period7Price: "",
					Period7ServicePrice: "",

					Period8BeginTime: "",
					Period8EndTime: "",
					Period8Price: "",
					Period8ServicePrice: "",

					Period9BeginTime: "",
					Period9EndTime: "",
					Period9Price: "",
					Period9ServicePrice: "",

					Period10BeginTime: "",
					Period10EndTime: "",
					Period10Price: "",
					Period10ServicePrice: "",

					Period11BeginTime: "",
					Period11EndTime: "",
					Period11Price: "",
					Period11ServicePrice: "",

					Period12BeginTime: "",
					Period12EndTime: "",
					Period12Price: "",
					Period12ServicePrice: ""
				},
				//档案-场站管理全部信息
				StationForm: {
					//前八个是某系整数结果代表什么意思的描述  用来配合显示
					StationTypeDesc: "公共",
					StationStatusDesc: "正常使用",
					StationPicturesArray: [],
					ConstructionDesc: "大型建筑配建停车场",
					ParkOpratorTypeDesc: "由本运营商自营",
					EvcsOperatorArray: [],
					Creator: "开发者",
					Modifier: "开发者",
					EquipmentNum: 2,
					ConnectorNum: 2,
					Id: 1,
					StationCode: "CSZD",
					StationName: "测试站点",
					OperatorId: "123456789",
					OperatorName: "深圳新能源科技有限公司",
					EquipmentOwnerId: "MA5DRRDX1",
					CountryCode: "CN",
					AreaCode: "440306",
					Address: "龙腾路1号",
					StationTel: "4006699082",
					ServiceTel: "4006699082",
					StationType: 1,
					StationStatus: 50,
					ParkNum: 0,
					Longitude: 114.029225,
					Latitude: 22.609581,
					SiteGuide: "",
					Construction: 9,
					StationPictures: "",
					MatchCar: "",
					ParkInfo: "",
					BusinessHours: "00:00-24:00",
					ElectricityFee: "00:00~07:00,0.232;07:00~09:00,0.676;09:00~11:30,1.028;11:30~14:00,0.676;14:00~16:30,1.028;16:30~19:00,0.676;19:00~21:00,1.028;21:00~23:00,0.676;23:00~24:00,0.232;",
					ServiceFee: "00:00~07:00,0.628;07:00~09:00,0.374;09:00~11:30,0.222;11:30~14:00,0.374;14:00~16:30,0.222;16:30~19:00,0.374;19:00~21:00,0.222;21:00~23:00,0.374;23:00~24:00,0.628;",
					ParkFee: "充电期间免停车费",
					PaymentMode: 34,
					SupportOrder: 0,
					QueryType: 8,
					Remark: "",
					ParkOwner: "",
					ParkManager: "",
					ParkOpenAllDay: 1,
					ParkFree: 1,
					ParkOpratorType: 1,
					IsScanCode: 0,
					DisparkDate: "",
					CollectionMch: 1,
					EvcsOperators: "",
					CreateBy: 1,
					CreateTime: "2021-03-22 13:58:12",
					ModifyBy: 1,
					ModifyTime: "2021-03-22 13:58:12"
				},
				BreadcrumbList: ['档案管理', '>>', '价格管理'],
				formInline: {
					StationId: 0
				},
				//table标题数据
				columns1: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: '抢编号',
						key: 'StationName',
					}, {
						title: '设备型号',
						key: 'Address',
					},
					{
						title: '设备类型',
						key: 'EquipmentNum',
						width: 100
					},
					{
						title: '所属场站',
						key: 'ConnectorNum',
						width: 100
					},
					{
						title: '当前模板',
						key: 'ConnectorNum',
						width: 100
					}, {
						title: '结果',
						key: 'ConnectorNum',
						width: 100
					}, {
						title: '操作',
						key: 'action',
						width: 100,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("updateStation", params.row.Id)
										}
									}
								}, '下发')
							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					Type: 1,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "addStation":
						this.modal.type = "addStation";
						this.modal.Title = "场站添加";
						break;
					case "updateStation":
						this.modal.type = "updateStation";
						this.modal.Title = "场站信息修改";
						this.getUpdateMessage(params);
						break;
				}
				this.modalView = true;
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "ChargePlatform/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				if (this.modal.type === "install") {
					//this.$refs.InstallForm.resetFields();
				} else if (this.modal.type === "addStation" || this.modal.type === "updateStation") {
					alert(111111111111111111)
					this.$refs.StationForm.resetFields();
				}
			},
			getUpdateMessage: function(Id) {
				console.log(Id);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].Id == Id) {
						_this.StationForm = _this.data1[i]
					}
				}
			},
			modalOk: function() {},
			//控制新增还是查询
			handleSubmitP: function() {
				this.ifAddPrice = !this.ifAddPrice;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-split {
		height: 97%;
		border: 5px solid #e2e2dc;
	}

	.demo-split-pane {
		padding: 10px;
	}
</style>
